// extracted by mini-css-extract-plugin
module.exports = {"icon":"_31C8NgLIrafPnAf3nCUpH2","boxSelect":"voQXlXTe6nVoKRnXo0_iB","layoutIcon":"_3Cyud6MNUL_TrOzgbv-lQK","active":"_2NZylCvSPhiJY7YegIwjy-"};